/**
 * String Format
 */
export class StringFormat {
    /**
     * Constructor
     * @param pattern pattern
     */
    constructor(pattern) {
        this.pattern = pattern;
    }
    /**
     * Implements format
     * @param value origin value
     */
    format(value) {
        if (!value) {
            return value;
        }
        let encodedValue = '';
        let patternChars = this.pattern.split('');
        let valueChars = value.split('');
        let valueCharsPosition = 0;
        for (let i = 0, size = patternChars.length; i < size; i++) {
            let patternChar = patternChars[i];
            if (patternChar === '#') {
                encodedValue += valueChars[valueCharsPosition++] || '';
            }
            else {
                encodedValue += patternChar;
            }
            if (valueCharsPosition >= valueChars.length) {
                break;
            }
        }
        return encodedValue;
    }
    /**
     * Implements parse
     * @param value formatted value
     */
    parse(value) {
        if (!value) {
            return value;
        }
        let decodedValue = '';
        let patternChars = this.pattern.split('');
        let valueChars = value.split('');
        let valueCharsPosition = 0;
        for (let i = 0, size = patternChars.length; i < size; i++) {
            let patternChar = patternChars[i];
            if (patternChar === '#') {
                decodedValue += valueChars[valueCharsPosition++] || '';
            }
            else {
                valueCharsPosition++;
            }
        }
        return decodedValue;
    }
}
//# sourceMappingURL=StringFormat.js.map